module.exports = __webpack_public_path__ + "img/icomoon.fe226d4.svg";